import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Experiences } from './pages/Experiences';
import { Skills } from './pages/Skills';
import { Impact } from './pages/Impact';
import { BoardCompetencies } from './pages/BoardCompetencies';
import { TrackRecord } from './pages/TrackRecord';
import { Systems } from './pages/Systems';
import { GovernancePage } from './pages/GovernancePage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31ctfztgrw49p">
      <div className="flex min-h-full w-full flex-col bg-white" data-id="element-1" data-mp="2wk0ah3dhcrwk">
        <Header data-id="element-2" data-mp="2wip54z4dzc3c" />
        <main className="flex-1" data-id="element-3" data-mp="2wi5nzkmk8rqd">
          <Routes data-id="element-4" data-mp="28tw9l3rof699">
            <Route path="/" element={<Home data-id="element-6" data-mp="28sl4n0mhvsgk" />} data-id="element-5" data-mp="28te3zgj4jfoo" />
            <Route path="/about" element={<About data-id="element-8" data-mp="23vulg4fe8gqx" />} data-id="element-7" data-mp="28s31dk1f0dz5" />
            <Route path="/experiences" element={<Experiences data-id="element-10" data-mp="23ti8k5ohswkq" />} data-id="element-9" data-mp="23ujlygszdv5m" />
            <Route path="/skills" element={<Skills data-id="element-12" data-mp="3ij66mgga9xb1" />} data-id="element-11" data-mp="3ikh829m9asyz" />
            <Route path="/impact" element={<Impact data-id="element-14" data-mp="3mlavl1vse5rc" />} data-id="element-13" data-mp="3ihv22ef0kliv" />
            <Route path="/board-competencies" element={<BoardCompetencies data-id="element-16" data-mp="3mjgannkimdn9" />} data-id="element-15" data-mp="3mkrgru1fnxhj" />
            <Route path="/track-record" element={<TrackRecord data-id="element-18" data-mp="3rdkgu4lyihna" />} data-id="element-17" data-mp="3rbr9en3irte8" />
            <Route path="/systems" element={<Systems data-id="element-20" data-mp="6hqffdy0fe4" />} data-id="element-19" data-mp="3recc1ebn6dd1" />
            <Route path="/governance" element={<GovernancePage data-id="element-22" data-mp="82k72sfnuax" />} data-id="element-21" data-mp="4wylxj0jajy" />
            <Route path="/contact" element={<ContactPage data-id="element-24" data-mp="2zmepackaxs9m" />} data-id="element-23" data-mp="2zld43f9knpe6" />
            <Route path="*" element={<Home data-id="element-26" data-mp="33morde4z3yj7" />} data-id="element-25" data-mp="2zn6b4vo3kbmp" />
          </Routes>
        </main>
        <Footer data-id="element-27" data-mp="33n6xr3lcnt4u" />
      </div>
    </BrowserRouter>;
}